import { jwtDecode } from 'jwt-decode';

export const getUserFullNameFromToken = (token) => {
  try {
    const decoded = jwtDecode(token);
    //console.log(decoded.userFullName);
    //console.log(decoded.userId);

    return decoded.userFullName;
  } catch (error) {
    console.error("Failed to decode token:", error);
    return null;
  }
};
